import type { EventGrandPrizeState } from "@/types";

export function createEmptyGrandPrizeState(): EventGrandPrizeState {
	return {
		chestKeys: 0,
		gemsEarnedToday: 0,
		chestKeysEarnedToday: 0,
		lastDailyFreePickedDaysAfterReg: 0,
	};
}

/** Reconcile local FE state with a server overview snapshot */
export function mergeGrandPrizeFullState(
	local: EventGrandPrizeState | null | undefined,
	remote: EventGrandPrizeState | null | undefined,
): EventGrandPrizeState | null {
	if (!remote && !local) return null;
	if (!remote) return local ?? null;
	if (!local) return remote;

	return {
		chestKeys: local.chestKeys ?? remote.chestKeys ?? 0,
		gemsEarnedToday: Math.max(
			local.gemsEarnedToday ?? 0,
			remote.gemsEarnedToday ?? 0,
		),
		chestKeysEarnedToday: Math.max(
			local.chestKeysEarnedToday ?? 0,
			remote.chestKeysEarnedToday ?? 0,
		),
		lastDailyFreePickedDaysAfterReg: Math.max(
			local.lastDailyFreePickedDaysAfterReg ?? 0,
			remote.lastDailyFreePickedDaysAfterReg ?? 0,
		),
	};
}

export function applyGrandPrizeStatePatch(
	local: EventGrandPrizeState | null | undefined,
	update: EventGrandPrizeState,
): EventGrandPrizeState {
	return local ? { ...local, ...update } : { ...update };
}
